import React, { Component } from 'react';
import { isEmpty } from '@js/utility/global';

class Breadcrumb extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { breadCrumb } = this.props;
    
    return (
      <>
        <nav aria-label="breadcrumb" id="breadcrumb">
          <div className="container">
            <ol className="breadcrumb header__breadcrumb">
              <li className="breadcrumb-item" aria-current="page">
                <a href="/">
                  <svg
                    id="home-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="21.865"
                    height="19.219"
                    viewBox="0 0 21.865 19.219"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Rectangle_2902"
                          data-name="Rectangle 2902"
                          width="21.865"
                          height="19.219"
                          fill="#c4bfc0"
                        />
                      </clipPath>
                    </defs>
                    <g id="Group_4376" data-name="Group 4376" clipPath="url(#clip-path)">
                      <path
                        id="Path_19572"
                        data-name="Path 19572"
                        d="M0,9.976c.177-.207.34-.433.532-.618Q2.581,7.385,4.641,5.426q1.575-1.5,3.153-3c.7-.664,1.388-1.338,2.09-2a1.488,1.488,0,0,1,2.107.009c1.062,1.006,2.115,2.023,3.173,3.035.021.02.045.036.1.076.006-.1.015-.164.015-.231q0-1.311,0-2.622c0-.5.134-.649.561-.649h2.357c.4,0,.546.164.546.628q0,2.992,0,5.985a.462.462,0,0,0,.152.374q1.346,1.271,2.684,2.551a2.96,2.96,0,0,1,.291.389v.28c-.285.4-.569.805-.856,1.2-.248.344-.47.374-.776.085-.815-.772-1.624-1.554-2.436-2.33q-1.071-1.024-2.144-2.046L13.441,5.057q-1.192-1.14-2.381-2.283a.152.152,0,0,0-.253,0Q9.721,3.825,8.628,4.866T6.456,6.939L4.272,9.025,1.835,11.354c-.094.09-.185.184-.284.264a.383.383,0,0,1-.621-.072c-.318-.422-.621-.859-.93-1.29Z"
                        transform="translate(0 0)"
                        fill="#c4bfc0"
                      />
                      <path
                        id="Path_19573"
                        data-name="Path 19573"
                        d="M52.454,70.6V65.388c-.077,0-.134-.009-.191-.009-1.03,0-2.061,0-3.091,0-.154,0-.2.047-.2.223.006,1.822,0,2.917,0,4.739v.283h-5.1c-.629,0-.975-.392-.975-1.112,0-2.4,0-4.065,0-6.461a.492.492,0,0,1,.177-.4c1.205-1.131,2.4-2.271,3.606-3.406q1.588-1.5,3.178-3c.282-.266.561-.535.849-.81l1.26,1.189,3.647,3.445q1.4,1.322,2.794,2.649a.4.4,0,0,1,.1.253c.005,2.456.007,4.185,0,6.641a.906.906,0,0,1-.869,1.006c-1.7.008-3.4,0-5.1,0a.926.926,0,0,1-.1-.015"
                        transform="translate(-39.785 -51.401)"
                        fill="#c4bfc0"
                      />
                    </g>
                  </svg>
                </a>
              </li>
              {!isEmpty(breadCrumb)
                ? breadCrumb?.map((item, index) => (
                    <li className="breadcrumb-item" key={`breadcrumbs${index}`}>
                      <a className="breadcrumb__link" href={item.link}>
                        {item.title}
                      </a>
                    </li>
                  ))
                : !isEmpty(window.breadcrumbs) &&
                  window.breadcrumbs?.map((item, index) => (
                    <li className="breadcrumb-item" key={`breadcrumbs${index}`}>
                      <a className="breadcrumb__link" href={item.link}>
                        {item.title}
                      </a>
                    </li>
                  ))}
            </ol>
          </div>
        </nav>
      </>
    );
  }
}
export default Breadcrumb;
